import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import Footer from '../Footer';
// import { Swiper, SwiperSlide } from 'swiper/react';
import Navigation from '../Navigation';

// TODO add a section below home that shows my works

const pi = 3.141592653589793238;

const Home = () => {
    const [columns, setColumns] = useState(0);
    const [rows, setRows] = useState(0);
    //   const [opened, setOpened] = useState(false);

    const handleMouseClick = (e) => {
        let { clientX, clientY } = e

        clientX += window.scrollX
        clientY += window.scrollY

        let col = Math.floor(clientX / 50) + 1;
        let row = Math.floor(clientY / 50) + 1;

        if (col > columns) col = columns;

        if (row > rows) row = rows;

        let max = Math.max(columns, rows)

        for (let j = 0; j < max; j++) {
            for (let i = 0; i < 360; i += 1) {
                const rad = i * (pi / 180);
                const x = Math.round(col + j * Math.cos(rad))
                const y = Math.round(row + j * Math.sin(rad))

                if (x > 0 && x <= columns && y > 0 && y <= rows) {
                    setTimeout(() => {
                        tileAnim(x, y);
                    }, 50 * j);
                }
            }
        }
    }

    useEffect(() => {
        const newColumns = Math.floor(window.innerWidth / 50);
        const newRows = Math.floor(window.innerHeight / 50);

        setColumns(newColumns);
        setRows(newRows);

        window.addEventListener('resize', updateGrid);
        return () => window.removeEventListener('resize', updateGrid);
    }, []);

    const updateGrid = () => {
        const newColumns = Math.floor(window.innerWidth / 50);
        const newRows = Math.floor(window.innerHeight / 50);

        setColumns(newColumns);
        setRows(newRows);
    };

    const createTile = (index) => {
        return <div key={index} className="tile"></div>;
    };

    const createTiles = (quantity) => {
        const tiles = Array.from(Array(quantity), (_, index) => createTile(index));
        return tiles;
    };

    const createGrid = () => {
        const tiles = createTiles(columns * rows);
        return tiles;
    };

    let currentAnimation = null;

    const tileAnim = (col, row) => {
        const tileIndex = col + (row - 1) * columns
        const tile = document.querySelector(`.tile:nth-child(${tileIndex})`)

        const keyframes = [
            { background: 'whitesmoke' },
            { background: '' }
        ];

        const timing = {
            duration: 500
        }

        if (tile) {
            tile.animate(keyframes, timing);

            currentAnimation = tile.animate(keyframes, timing);

            currentAnimation.onfinish = () => {
                currentAnimation = null;
            };
        }
    };

    const handleMouseMove = (e) => {
        let { clientX, clientY } = e;

        clientX += window.scrollX
        clientY += window.scrollY

        let col = Math.floor(clientX / 50) + 1;
        let row = Math.floor(clientY / 50) + 1;

        if (col > columns) {
            col = columns;
        }

        if (row > rows) {
            row = rows;
        }

        tileAnim(col, row);
    };

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [])

    return (
        <Fragment>
            <div className="home-wrapper">
                <div className="home-container" onMouseMove={handleMouseMove} onClick={handleMouseClick}>

                    {
                        window.innerWidth > 768
                            ? (
                                <div className="home-navigation">
                                    <div className="logo-container">
                                        <Link className="logo" to={'/'}>
                                            <div className="ico">

                                            </div>
                                            <div className="text">
                                                Yujaw
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="navigation-wrapper">
                                        <div className="navigation">
                                            {/* <Link to={'/portfolio'}>portfolio</Link> */}
                                            <Link to={'/outreach'}>outreach</Link>
                                            <Link to={'/resume'}>resume</Link>
                                            <Link to={'/hobby'}>hobbies</Link>
                                            <Link to={'/about'}>about</Link>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Navigation />
                            )
                    }
                    {
                        window.innerWidth > 768
                            ? (
                                <div className="wrapper" style={{ '--columns': columns, '--rows': rows }}>
                                    {
                                        createGrid()
                                    }
                                </div>
                            ) : null
                    }
                    <div className="content">
                        <div className="left">
                            <div className='text'>
                                Developer & Student based in Dayton, Ohio.
                            </div>
                        </div>
                        <div className="right">
                            <span>Hello<span>. </span></span>
                            <span>I am </span>
                            <span>Yujaw</span>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
};

export default Home;